import type { ReactNode } from 'react'

/** Keeps children on one line so a wrap happens before this phrase, not inside it. */
export function KeepTogether({ children }: { children: ReactNode }) {
  return <span className="whitespace-nowrap">{children}</span>
}
